import { render, staticRenderFns } from "./DispoHome.vue?vue&type=template&id=aea1a238&scoped=true&"
import script from "./DispoHome.vue?vue&type=script&lang=js&"
export * from "./DispoHome.vue?vue&type=script&lang=js&"
import style0 from "./DispoHome.vue?vue&type=style&index=0&id=aea1a238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea1a238",
  null
  
)

export default component.exports